import colorNames from "colornames"

export function colourToHex(colourName: string) {
  if(colourName.startsWith("#") && colourName.length === 7) return colourName
  try {
    return colorNames.get(colourName).value
  } catch (e) {
    console.warn("Unknown colour name", colourName)
    return colourName
  }
}
